import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md"; 

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="d-flex justify-content-center">
          <Col md={8} className="home-about-description text-center">
            <h1 style={{ fontSize: "2.6em" }}>
              Acerca de <span className="purple">mí</span>
            </h1>

            <p className="home-about-body" style={{ textAlign: "justify" }}>
              Soy Jorge, <b className="purple">geógrafo</b> interesado en las ciudades,
              los datos y el poder de los mapas para comprender el espacio urbano.
              Trabajo en la intersección entre el <b className="purple">análisis espacial</b> y el <b className="purple">pensamiento urbano crítico</b>.
              <br />
              <br />
              Creo que la geografía no solo describe el mundo —
              <b className="purple"> lo cuestiona</b>.
              <br />
              <br />
            </p>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>Contacto</h1>
            <p>
              Sientete libre de <span className="purple">contactarme </span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Jap-25"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:jorge.aravena.pena@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <MdEmail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/jorge-aravena-peña-248780162/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/la.tierra.es.plana"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
